var render = function () {
  var _vm$goodsList, _vm$goodsList$0$packa, _vm$goodsList$0$packa2, _vm$goodsList$0$packa3, _vm$goodsList$0$packa4, _vm$goodsList$0$packa5, _vm$goodsList$0$packa6, _vm$goodsList$0$packa7, _vm$goodsList$0$packa8, _vm$goodsList$0$packa9;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return ((_vm$goodsList = _vm.goodsList) === null || _vm$goodsList === void 0 ? void 0 : _vm$goodsList.length) > 0 ? _c('div', {
    staticClass: "packageWrap"
  }, [_c('div', {
    staticClass: "packageLeft"
  }, [_c('p', {
    staticClass: "fs14 fwb mb6"
  }, [_vm._v(" " + _vm._s((_vm$goodsList$0$packa = _vm.goodsList[0].package) === null || _vm$goodsList$0$packa === void 0 ? void 0 : _vm$goodsList$0$packa.packageName) + " ")]), _c('p', [_c('span', {
    staticClass: "fs20 fwb orange"
  }, [_vm._v(_vm._s(_vm.currencyAndAmountFormat((_vm$goodsList$0$packa2 = _vm.goodsList[0].package) === null || _vm$goodsList$0$packa2 === void 0 ? void 0 : _vm$goodsList$0$packa2.currency, (_vm$goodsList$0$packa3 = _vm.goodsList[0].package) === null || _vm$goodsList$0$packa3 === void 0 ? void 0 : _vm$goodsList$0$packa3.price)))]), _c('span', {
    staticClass: "fs14 tdlt ml6 fwb blackD8"
  }, [_vm._v("(" + _vm._s(_vm.serviceListPriceSum((_vm$goodsList$0$packa4 = _vm.goodsList[0].package) === null || _vm$goodsList$0$packa4 === void 0 ? void 0 : _vm$goodsList$0$packa4.serviceList, (_vm$goodsList$0$packa5 = _vm.goodsList[0].package) === null || _vm$goodsList$0$packa5 === void 0 ? void 0 : _vm$goodsList$0$packa5.currency)) + ")")])]), _c('div', {
    staticClass: "pt10"
  }, [_c('p', {
    staticClass: "fs12"
  }, [_vm._v("Exclusive for:")]), _c('p', {
    staticClass: "fs12 black88"
  }, [_vm._v(" " + _vm._s((_vm$goodsList$0$packa6 = _vm.goodsList[0].package) === null || _vm$goodsList$0$packa6 === void 0 ? void 0 : _vm$goodsList$0$packa6.applicablePerson) + " ")])])]), _c('div', {
    staticClass: "packageRight"
  }, [_c('div', {
    staticClass: "flex flex-direction-row details"
  }, [_c('div', {
    staticClass: "mr20"
  }, [_c('p', {
    staticClass: "fs12 fwb"
  }, [_vm._v("Package Includes:")]), _c('ul', {
    staticClass: "fs12 black45 lh22"
  }, _vm._l((_vm$goodsList$0$packa7 = _vm.goodsList[0].package) === null || _vm$goodsList$0$packa7 === void 0 ? void 0 : _vm$goodsList$0$packa7.serviceList, function (child) {
    return _c('li', {
      key: 'child' + child.id
    }, [_c('span', {
      staticClass: "fwb green fs12 el-icon-check"
    }), _vm._v(" " + _vm._s(child.description) + " "), _vm.$isNumberLike(child.serviceFee) ? _c('span', [_vm._v("(" + _vm._s(_vm.currencyAndAmountFormat(child.currency, child.serviceFee)) + ")")]) : _vm._e(), child.serviceScope ? _c('el-popover', {
      attrs: {
        "placement": "bottom",
        "trigger": "hover"
      }
    }, [_c('span', {
      staticClass: "fs12"
    }, [_vm._v(_vm._s(child.serviceScope))]), _c('span', {
      staticClass: "ml2 fs13 blackD8 el-icon-question",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    })]) : _vm._e()], 1);
  }), 0)]), _c('div', {
    staticClass: "mr20"
  }, [_vm._m(0), _c('ul', {
    staticClass: "fs12 black45 lh22"
  }, _vm._l(_vm.mergeSameAttrList((_vm$goodsList$0$packa8 = _vm.goodsList[0].package) === null || _vm$goodsList$0$packa8 === void 0 ? void 0 : _vm$goodsList$0$packa8.serviceList, 'thirdPartyFeeDescription', 'thirdPartyFee'), function (subset) {
    return _c('li', {
      key: "subset-".concat(subset.id)
    }, [subset.thirdPartyFeeDescription ? _c('span', [_vm._v("- " + _vm._s(subset.thirdPartyFeeDescription))]) : _vm._e(), _vm.$isNumberLike(subset.thirdPartyFee) ? _c('span', [_vm._v("(" + _vm._s(_vm.currencyAndAmountFormat(subset.currency, subset.thirdPartyFee)) + ")")]) : _vm._e()]);
  }), 0)]), _c('div', [_vm._m(1), _c('ul', {
    staticClass: "fs12 black45 lh22"
  }, _vm._l(_vm.mergeSameAttrList((_vm$goodsList$0$packa9 = _vm.goodsList[0].package) === null || _vm$goodsList$0$packa9 === void 0 ? void 0 : _vm$goodsList$0$packa9.serviceList, 'otherFeeDescription', 'otherFee'), function (other) {
    return _c('li', {
      key: "other-".concat(other.id)
    }, [other.otherFeeDescription ? _c('span', [_vm._v("- " + _vm._s(other.otherFeeDescription))]) : _vm._e(), _vm.$isNumberLike(other.otherFee) ? _c('span', [_vm._v("(" + _vm._s(_vm.currencyAndAmountFormat(other.currency, other.otherFee)) + ")")]) : _vm._e()]);
  }), 0)])])])]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "fs12 pt18 lh22"
  }, [_c('span', {
    staticClass: "fwb green fs12 el-icon-check"
  }), _vm._v(" Third Party Fee: ")]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "fs12 pt18 lh22"
  }, [_c('span', {
    staticClass: "fwb green fs12 el-icon-check"
  }), _vm._v(" Other Fee: ")]);
}]

export { render, staticRenderFns }